// Below this width Oliver's side panels slide over the chat instead of sitting
// beside it, so they never open on their own and close once they have done their job.
export const NARROW_PANEL_WIDTH = 580;
